import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'




Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '节点小宝'
    },
  },
  {
    path: '/bt',
    name: 'bt',
    component: Home,
    meta: {
      title: '节点小宝'
    },
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? "/landing/" : process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});

export default router
